<template>
<b-container class="services-small">
    <b-row>
        <b-col cols="12" md="4" class="mb-3 mb-md-0">
            <router-link :to="{ path: '/', hash: '#ritningar' }" class="service-tile md-surface">
                <span class="md-icon"><inline-svg :src="svg('pen-tool.svg')" width="24" height="24" /></span>
                <span>Ritningar</span>
            </router-link>
        </b-col>
        <b-col cols="12" md="4" class="mb-3 mb-md-0">
            <router-link :to="{ path: '/', hash: '#kontrollansvar' }" class="service-tile md-surface">
                <span class="md-icon"><inline-svg :src="svg('clipboard.svg')" width="24" height="24" /></span>
                <span>Kontrollansvar, KA</span>
            </router-link>
        </b-col>
        <b-col cols="12" md="4">
            <router-link :to="{ path: '/', hash: '#redovisning' }" class="service-tile md-surface">
                <span class="md-icon"><inline-svg :src="svg('trending-up.svg')" width="24" height="24" /></span>
                <span>Redovisningstjänster</span>
            </router-link>
        </b-col>
    </b-row>
</b-container>
</template>

<script>
export default {
    name: 'ServicesSmall',
    methods: {
        svg(path) {
            return this.$images.svg(path);
        }
    }
};
</script>
